import _ from 'lodash';
import React, { Component } from 'react';

import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import { ICorpPermissionRoleJson } from '@scale/shared/types/corppermissionrole';

interface SelectOption {
  label: string;
  value: string;
}

interface IFindPermissionRolesResponse {
  corpPermissionRoles: Partial<ICorpPermissionRoleJson>[];
}

interface ISelectPermissionRoleProps {
  value?: SelectOption;
  onChange?: (value?: SelectOption) => void;
  placeholder?: string;
  disabled?: boolean;
}

export default class SelectPermissionRole extends Component<ISelectPermissionRoleProps> {
  static defaultProps = {
    placeholder: 'Select a corp permission role',
  };

  async fetchCorpPermissionRoles(search: string) {
    if (!search) {
      return [];
    }

    try {
      const results: IFindPermissionRolesResponse = await apiFetch(
        null,
        `corp-api/find/corppermissionroles`,
        {
          query: Object.assign({}, _.pickBy({ search })),
        },
      );

      const options: SelectOption[] = results.corpPermissionRoles.map(role => {
        return {
          label: `${role.name} (${role._id})`,
          value: role._id!,
        };
      });

      return { options };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  }

  render() {
    return (
      <React.Fragment>
        <Select
          {...this.props}
          loadOptions={this.fetchCorpPermissionRoles.bind(this)}
          ignoreCase={false}
        />
      </React.Fragment>
    );
  }
}
